//@ts-ignore
import ErrorPage, { PAGE_TYPES } from '@mindtickle/error-page';
//@ts-ignore
import Loader from '@mindtickle/loader';

export const DEFAULT_ERROR_FALLBACK = () => (
  <ErrorPage
    tryAgain={() => window.location?.reload()}
    centered={true}
    pageType={PAGE_TYPES.CLIENT_ERROR}
    showGoToHome={false}
    showLogo={false}
  />
);

export const DEFAULT_DELAYED_FALLBACK = () => <Loader type="Full" />;

export const LOGGER_NAME = 'dynamic-remote';

export const PERFORMANCE_MEASURE_NAMES = {
  REMOTE_LOADED: 'remoteLoaded',
  MODULE_EVALUATION_COMPLETED: 'moduleEvaluationCompleted',
};
